var privacylinerSwiper = new Swiper(".privacyliner .bannerSwiper-container", {
  direction: "horizontal",
  slidesPerView: 1,
  spaceBetween: 0,
  // 如果需要前进后退按钮
  navigation: {
    nextEl: ".privacyliner .banner_slider .next-icon",
    prevEl: ".privacyliner .banner_slider .prev_icon",
  },
  observer: true, //开启动态检查器
  on: {
    observerUpdate: function () { },
    resize: function () { },
  },
  pagination: {
    el: ".privacyliner .swiper-pagination",
    clickable: true,
  },
});
var softflatSwiper = new Swiper(".softflat .bannerSwiper-container", {
  direction: "horizontal",
  slidesPerView: 1,
  spaceBetween: 0,
  // 如果需要前进后退按钮
  navigation: {
    nextEl: ".softflat .banner_slider .next-icon",
    prevEl: ".softflat .banner_slider .prev_icon",
  },
  observer: true, //开启动态检查器
  on: {
    observerUpdate: function () { },
    resize: function () { },
  },
  pagination: {
    el: ".softflat .swiper-pagination",
    clickable: true,
  },
});
var thicksatinSwiper = new Swiper(".thicksatin .bannerSwiper-container", {
  direction: "horizontal",
  slidesPerView: 1,
  spaceBetween: 0,
  // 如果需要前进后退按钮
  navigation: {
    nextEl: ".thicksatin .banner_slider .next-icon",
    prevEl: ".thicksatin .banner_slider .prev_icon",
  },
  observer: true, //开启动态检查器
  on: {
    observerUpdate: function () { },
    resize: function () { },
  },
  pagination: {
    el: ".thicksatin .swiper-pagination",
    clickable: true,
  },
});
var blackoutSwiper = new Swiper(".blackout .bannerSwiper-container", {
  direction: "horizontal",
  slidesPerView: 1,
  spaceBetween: 0,
  // 如果需要前进后退按钮
  navigation: {
    nextEl: ".blackout .banner_slider .next-icon",
    prevEl: ".blackout .banner_slider .prev_icon",
  },
  observer: true, //开启动态检查器
  on: {
    observerUpdate: function () { },
    resize: function () { },
  },
  pagination: {
    el: ".blackout .swiper-pagination",
    clickable: true,
  },
});
var softSwiper = new Swiper(".soft .bannerSwiper-container", {
  direction: "horizontal",
  slidesPerView: 1,
  spaceBetween: 0,
  // 如果需要前进后退按钮
  navigation: {
    nextEl: ".soft .banner_slider .next-icon",
    prevEl: ".soft .banner_slider .prev_icon",
  },
  observer: true, //开启动态检查器
  on: {
    observerUpdate: function () { },
    resize: function () { },
  },
  pagination: {
    el: ".soft .swiper-pagination",
    clickable: true,
  },
});

$(".textHidden .more").on("click", function () {
  $(this).closest(".textHidden").find("p").css("display", "block");
  $(this).css("display", "none");
});
